<template>
    <v-card min-width="326">
      <v-card-title><T>Дата доставки</T></v-card-title>
      <v-divider></v-divider>
      <v-calendar-weekly
        v-model="deliveryDate"
        :locale="$store.getters.locale_metadata.Language.replace('_', '-')"
        :weekdays="[1,2,3,4,5,6,0]"
        :weekday-format="weekdayFormat"
        :end="month"
      >
        <template v-slot:day-label="date">
            <v-btn
                fab
                small
                elevation="0"
                :color="deliveryDate == date.date ? 'primary' : ''"
                :disabled="!getTime(date).is_workday || new Date(date.date) > month || new Date(date.date) < today.setHours(0,0,0,0) "
                @click="setActiveDate(date)"
            >
                {{date.day}}
            </v-btn>
        </template>

        <template v-slot:day="date">
          <slot name="day">
            <div class="block" :style="getBlockStyle(date)">{{getBlockContent(date)}}</div>
          </slot>
        </template>
      </v-calendar-weekly>
    </v-card>
  </template>
  
<script>
import { DateTime } from 'luxon'

export default {
    props: {
        value: [Date, Object],
        config: Array, 
        max_days:{
            type: Number,
            default: 21
        },
    },
    data: () => ({
    }),
    methods: {
        weekdayFormat(date_dict) {
            let days = [
            this.$t('вс'),
            this.$t('пн'),
            this.$t('вт'),
            this.$t('ср'),
            this.$t('чт'),
            this.$t('пт'),
            this.$t('сб'),
            ]
            return days[date_dict.weekday]
        },
        getInterceptedInterval(date){
            if (!this.config) {
                return undefined
            }

            // let intercepted_interval = undefined
            let intervals = JSON.parse(JSON.stringify(this.config))
            
            for (const [idx, interval] of intervals.reverse().entries()) {
                
                if (interval.mode == 'DAYOFWEEK') {
                    if (interval.day_of_week.includes(date.weekday == 0 ? 6 : date.weekday - 1)) {
                        return [Math.abs(intervals.length - 1 - idx), interval]
                    }
                } else {
                    let current_date = new Date(date.date)
                    let int_start = new Date(interval.str_date_start)
                    let int_end = new Date(interval.str_date_end)
                    
                    if ((current_date >= int_start) && (current_date <= int_end)) {
                        return [Math.abs(intervals.length - 1 - idx), interval]
                    }
                }
            }
            return undefined
        },
        getBlockStyle(date){
            let pair = this.getInterceptedInterval(date)

            if (pair) {
                let [idx, interval] = pair

                const colors = this.colors
                const color = colors[idx % colors.length]

                if (interval.is_workday) {
                    return `background-color: ${color}`
                } else {
                    return `background-color: var(--v-secondary-base); text-align: center`
                }
            }

            return 'line-height: 2em; color: black'
        },
        getTime(date){  
            let pair = this.getInterceptedInterval(date)
            return pair[1]
        },
        getBlockContent(date){
            let pair = this.getInterceptedInterval(date)

            if (pair) {
                let interval = pair[1]

                if (interval.is_workday) {
                    return `${interval.str_time_start}   ${interval.str_time_end}`
                } else {
                    return `___`
                }
            }

            return '<?>'
        },
        format_date(date){
            let month = (''+(date.getMonth()+1)).length < 2 ? `0${date.getMonth()+1}` : date.getMonth()+1
            let day =  (''+date.getDate()).length < 2 ? `0${date.getDate()}` : date.getDate()
            return `${date.getFullYear()}-${month}-${day}`              
        },
        setActiveDate(date){
            let pair = this.getInterceptedInterval(date)
            this.deliveryDate = date

            this.$emit('range', pair[1])
        }
    },
    computed: {
        deliveryDate:{
            set(v){
                this.$emit('input', DateTime.fromISO(v.date).set({hour: this.value.hour, minute: this.value.minute}))
                this.$emit('picked')
              },
            get(){
                // let month = (''+(this.value.getMonth()+1)).length < 2 ? `0${this.value.getMonth()+1}` : this.value.getMonth()+1
                // let day =  (''+this.value.getDate()).length < 2 ? `0${this.value.getDate()}` : this.value.getDate()
                // return `${this.value.getFullYear()}-${month}-${day}`
                return this.value.toFormat('yyyy-LL-dd')
            }
        },
        work_days(){
            let start = new Date(this.deliveryDate)
            let days_arr = []
            while(start.setHours(0,0,0,0) != new Date(this.month).setHours(0,0,0,0)){
                let interval = this.getInterceptedInterval({date: new Date(start), weekday: start.getDay()})[1]
                days_arr.push({date: this.format_date(start), is_workday: interval.is_workday, interval: interval})
                start.setDate(start.getDate()+1)
            }
            return days_arr
        },
        today(){
            return new Date()
        },
        month(){
            let month = new Date(this.today)
            month.setDate(this.today.getDate() + this.max_days)
            return month
        },
        colors(){
            return [
                'var(--v-primary-base)',
                'var(--v-info-base)',
                'var(--v-primary-darken4)',
                'var(--v-info-darken3)',
                'var(--v-info-darken1)',
                'var(--v-primary-darken1)',
                'var(--v-info-lighten3)',
                'var(--v-primary-darken3)',
                'var(--v-primary-darken2)',
                'var(--v-info-lighten2)',
                'var(--v-info-lighten1)',
                'var(--v-info-darken2)',
            ]
        }
    },
    mounted(){
        let date = {date: this.deliveryDate, weekday: new Date(this.deliveryDate).getDay()}
        if(!this.getTime(date).is_workday){
            let temp = this.work_days.findIndex(item => item.date == date.date)

            for(let i = temp; i<this.work_days.length; i++){
                if(this.work_days[i].is_workday){
                    this.$emit('input', new Date(this.work_days[i].date))
                    this.$emit('range', this.work_days[i].interval)
                    return
                }
            }
            return this.$emit('input', 'По графику нет рабочих дней')
        }else{
            this.setActiveDate(date)
        }
    },
    wacth:{
    },
    components:{
    }
}
</script>
  
  <style scoped>
  .block {
    height: 2.5em;
    margin: .5em .1em;
    content: " ";
    line-height: 1em;
    font-family: monospace;
    /* width: 100%; */
    border-radius: .3em;
    overflow-y: visible;
    color: white;
    padding: .3em;
  
    font-size: .8rem;
    text-align: center;
  }
  </style>